import React from 'react';
import { Wrench, Activity, Package, Shield, Headphones, BarChart3, TrendingUp, Users, Clock, CheckCircle2 } from 'lucide-react';

export const Operations = () => {
  const operations = [
    {
      icon: Wrench,
      title: 'Instalación',
      description: 'Configuración completa sin costo para tu organización.'
    },
    {
      icon: Activity,
      title: 'Operación',
      description: 'Monitoreo, reposición de productos y mantenimiento.'
    },
    {
      icon: Headphones,
      title: 'Soporte',
      description: 'Asistencia rápida cuando se necesite.'
    }
  ];

  const benefits = [
    {
      icon: TrendingUp,
      text: 'Mejora la experiencia de usuarios y visitantes'
    },
    {
      icon: Clock,
      text: 'Facilita pausas durante la jornada'
    },
    {
      icon: Users,
      text: 'Aumenta la comodidad en espacios comunes'
    },
    {
      icon: CheckCircle2,
      text: 'No requiere inversión ni gestión administrativa'
    }
  ];

  return (
    <section id="nosotros" className="py-12 md:py-16 bg-gradient-to-b from-white to-[#F8F5F0] relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 bg-[#B25F3F]/10 text-[#B25F3F] text-sm font-semibold rounded-full mb-4">
            Operación completa
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-[#003847] mb-6">
            Nosotros nos encargamos de todo
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
            <span className="font-semibold text-[#003847]">Implementación simple. Beneficio inmediato.</span>
            <br />
            BOCADIA gestiona completamente la operación para que tú solo disfrutes del beneficio.
          </p>
        </div>

        {/* Operations Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mb-16">
          {operations.map((operation, index) => {
            const Icon = operation.icon;
            return (
              <div
                key={index}
                className="group relative bg-white p-6 md:p-8 rounded-2xl shadow-md hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-gray-100"
              >
                {/* Icon Container */}
                <div className="flex flex-col items-center text-center gap-4 mb-4">
                  <div className="flex-shrink-0 w-16 h-16 bg-gradient-to-br from-[#CFAE70] to-[#B89A5F] rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-lg">
                    <Icon className="w-8 h-8 text-white" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl md:text-2xl font-bold text-[#003847] mb-3">
                      {operation.title}
                    </h3>
                    <p className="text-base text-gray-600 leading-relaxed">
                      {operation.description}
                    </p>
                  </div>
                </div>

                {/* Hover Border Effect */}
                <div className="absolute inset-0 rounded-2xl border-2 border-[#CFAE70] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
            );
          })}
        </div>

        {/* Image Section */}
        <div className="relative rounded-3xl overflow-hidden shadow-2xl">
          <img
            src="https://customer-assets.emergentagent.com/job_smart-snacks/artifacts/l36z08su_imagen%204.png"
            alt="People enjoying coffee near BOCADIA vending machine"
            className="w-full h-[580px] md:h-[680px] object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#003847]/80 via-[#003847]/20 to-transparent flex items-end">
            <div className="p-8 md:p-12 text-white max-w-3xl">
              <h3 className="text-2xl md:text-3xl font-bold mb-3 md:mb-4">
                Mejora la experiencia dentro de tu espacio
              </h3>
              <p className="text-base md:text-lg text-white/95 leading-relaxed">
                BOCADIA convierte áreas comunes en puntos de conveniencia donde colaboradores, estudiantes o visitantes pueden acceder fácilmente a café, bebidas y snacks.
              </p>
            </div>
          </div>
        </div>

        {/* Benefits Section */}
        <div id="beneficios" className="mt-16 bg-gradient-to-br from-[#003847] to-[#004555] rounded-3xl p-8 md:p-16 shadow-2xl">
          <h3 className="text-2xl md:text-4xl font-bold text-white text-center mb-8 md:mb-12">
            Beneficios para tu espacio
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
            {benefits.map((benefit, index) => {
              const Icon = benefit.icon;
              return (
                <div
                  key={index}
                  className="flex items-center gap-3 md:gap-4 p-4 md:p-6 bg-white/10 backdrop-blur-sm rounded-xl hover:bg-white/20 transition-all duration-300 border border-white/20"
                >
                  <Icon className="w-6 h-6 md:w-8 md:h-8 text-[#CFAE70] flex-shrink-0" />
                  <p className="text-white text-base md:text-lg">{benefit.text}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
